import {
    BaseService
} from "./BaseService";
import {
    SnackBarModule
} from "../modules/SnackBarModule";

export const FeriasEscolaresService = {
    async getFerias(postData) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ferias-escolares/buscar-alunos`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return response.message;
    },

    async getFeriasEscolares(postData) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ferias-escolares`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return response.message;
    },

    
    async getExerciciosPesquisar() {
        const response = await BaseService.fetchResponseFromAPIGet(`ferias-escolares/exercicio`);
        if (response.error) {
            SnackBarModule("Houve um erro ao listar os exercícios", "error");
        }
        return response.content;
    },

    async getExercicios(idSigrh) {
        const response = await BaseService.fetchResponseFromAPIGet(`ferias-escolares/exercicio/${idSigrh}`);
        if (response.error) {
            SnackBarModule("Houve um erro ao listar os exercícios", "error");
        }
        return response.content;
    },

    async agendarFeriasEscolares(postData) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ferias-escolares/agendar-ferias`,
            postData);
        if (response.error) {
            SnackBarModule(response.message.error, "error");
            return false;
        }
        SnackBarModule("Enviado com sucesso", "success");
        return true;
    },

    async saveUnidadesDeEnsino(postData) {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ferias-escolares/salvar-unidades-ensino`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        SnackBarModule("Enviado com sucesso", "success");
        return true;
    },

    async listarAlunosEmCurso() {
        const response = await BaseService.fetchResponseFromAPIGet(`ferias-escolares/alunos-em-curso`);
        if (response.error) {
            SnackBarModule("Houve um erro ao listar as unidades", "error");
        }
        return response.content;
    },

    async listarAlunosEmFerias() {
        const response = await BaseService.fetchResponseFromAPIGet(`ferias-escolares/alunos-ferias`);
        if (response.error) {
            SnackBarModule("Houve um erro ao listar as unidades", "error");
        }
        return response.content;
    },

    async verificaSeUnidadePermiteDefinirFerias(unidadeId) {
        const response = await BaseService.fetchResponseFromAPIGet(`ferias-escolares/permite-definir-ferias-escolares/${unidadeId}`);
        if (response.error) {
            SnackBarModule("Houve um erro ao verificar se unidade pode definir férias escolares", "error");
        }
        return response.content;
    },

    async listaUnidadesDeEnsino() {
        const response = await BaseService.fetchResponseFromAPIGet(`ferias-escolares/busca-unidades-ensino`);
        if (response.error) {
            SnackBarModule("Houve um erro ao buscar todas unidades de ensino", "error");
        }
        return response.content;
    },

    async listaMilitaresEmCurso (filter) {
        const response = await BaseService.fetchResponseFromAPIPost(`ferias-escolares/militares-em-curso`, filter);
        if (response.error) {
          SnackBarModule("Houve um erro ao verificar permissão", "error");
        }
        return response.message;
    },

}